export const en = {
  changelogLoadError: "Error: unable to load changelog file.",
  searchExistingTropes: "Search tropes...",
  listExportErrorNoConnection:
    "Unable to retrieve sources of terms from the database.",
  listExportErrorNoTerms: "No file generated, as it would be empty.",
  listExportAlert:
    "This export leaves out terms without a set type stereotype.",
  rename: "Rename",
  renameDiagram: "Rename diagram ",
  renameDiagramEmptyInput: "Please input a name",
  cardinalities: "Cardinalities",
  noOptions: "No options available",
  unknown: "Not available",
  vocabularySelectInfo:
    "Controls the vocabularies to which this diagram is attached. When a vocabulary is added into a Control Panel projects, only those diagrams assigned to that vocabulary are available.",
  addLanguage: "Add language input",
  removeLanguage: "Remove last added language input",
  modalNewTropeDescription:
    "Enter a label for the new trope (these cannot be changed later!):",
  modalNewRelationshipDescription:
    "Enter a label for the new relationship (these cannot be changed later!):",
  createTrope: "Create new trope",
  assignExistingTrope: "Assign existing trope",
  noExistingTropes:
    "There are no existing tropes to be assigned. Please unassign a trope from another term or create a new trope.",
  assignTropeHeader: "Assign trope to ",
  assignTropeConfirm: "Assign trope",
  mustAssignTropeConfirm:
    "You have to select a trope from the list to continue.",
  deleteLink: "Delete relationship",
  openDiagram: "Open diagram",
  closeDiagram: "Close diagram",
  deleteDiagram: "Delete diagram",
  createDiagram: "Create new diagram",
  showPreview: "Show preview",
  collaborators: "Collaborators:",
  linkInfo: "Show connection details",
  name: "Name",
  vocabularies: "Vocabularies",
  lastModifiedDate: "Last modified on:",
  creationDate: "Created on:",
  untitledProject: "OntoGrapher",
  unsorted: "No type",
  updating: "Saving...",
  removeConcept: "Delete term",
  writeEnabledVocabulary: "This is an editable vocabulary.",
  readOnlyVocabulary: "This is a vocabulary whose terms are read-only.",
  newVersion:
    "OntoGrapher has been updated with new functions since you were gone! Click here to see a detailed changelog.",
  retry: "Retry?",
  errorUpdating: "Error: update unsuccessful.",
  workspaceReady: "Ready for work. Your changes are saved as they happen.",
  filterVocabulariesPlaceholder: "Pick vocabularies...",
  termsFromOtherVocabularies: "Terms from other vocabularies",
  modalNewElemLengthError: "The name must have between 2 and 150 characters.",
  modalNewElemCharacterError: "The name has to have non-special characters.",
  modalNewElemIRI: "The term will be created using IRI:",
  term: "term",
  termsCase: "terms",
  authenticationError:
    "Authentication error. Please contact the server administrator.",
  authenticationUpdateError: "Authentication error. Please refresh the page.",
  authenticationExpired: "Authentication expired. Please refresh the page.",
  authenticationTimeout: "Request to authentication service timed out.",
  logout: "Log out",
  detailPanelMultipleLinks: "Multiple selected links",
  detailPanelMultipleRelationships: "Multiple selected relationships",
  detailPanelMultipleLinksEditable:
    "Cardinalities can be assigned to the following links from the selection:",
  detailPanelMultipleRelationshipsEditable:
    "Cardinalities can be assigned to the following relationships from the selection:",
  detailPanelMultipleLinksNotEditable:
    "Cardinalities cannot be assigned to any links from the selection.",
  detailPanelMultipleRelationshipsNotEditable:
    "Cardinalities cannot be assigned to any relationships from the selection.",
  detailPanelPrefLabel: "Label",
  detailPanelAltLabel: "Synonyms",
  detailPanelInScheme: "In vocabulary",
  detailPanelDefinition: "Definition",
  detailPanelStereotype: "Stereotype",
  setCanvasLanguage: "Displayed vocabulary language",
  setInterfaceLanguage: "User interface language",
  ontoGrapher: "OntoGrapher",
  errorMissingRestriction: "Restriction not found",
  validationNumber: "#",
  hiddenTermsAndLinks:
    "Some terms or links are hidden in Compact view. To see them again, switch to Full view.",
  validationName: "Label",
  validationSeverity: "Severity",
  errorConnectionLost: "Error: connection to database lost.",
  diagramTab: "Diagrams",
  modalNewElemExistsError:
    "A term with this label already exists in the vocabulary.",
  addAltLabelPlaceholder: "Add new synonym",
  addAltLabel: "New synonym",
  addAltLabelNoName: "Please input a synonym.",
  setAsDisplayName: "Set as display label",
  conforms: "All terms and relationships conform to validation rules",
  validationError: "Message",
  validationReload: "Refresh",
  validation: "Validation",
  downloadDiagramImage: "Download image",
  previewDiagramImage: "Create preview",
  exportDiagram: "Export diagram...",
  generateDiagramImageModalTitle: "Export diagram ",
  generateDiagramList: "As term list",
  generateDiagramImage: "As image",
  downloadDiagramList: "Download list",
  generateDiagramListType: "File type",
  settings: "Settings",
  preview: "Preview",
  language: "Language",
  representation: "Representation",
  representationCompact: "Compact",
  format: "File format",
  representationFull: "Full",
  generateDiagramImageInBlackAndWhite: "Render in black & white",
  generateDiagramNoElementsError:
    "Cannot generate image as no terms are present in the diagram.",
  setStereotypeUML: "Set Type stereotype",
  setStereotypeData: "Set OntoUML stereotype",
  noStereotypeUML: "No Type stereotype",
  noStereotypeData: "No OntoUML stereotype",
  anyStereotypeType: "Any Type stereotype",
  anyStereotypeOnto: "Any OntoUML stereotype",
  anyLink: "Any link",
  anyVocabulary: "Any vocabulary",
  filterSearchPlaceholder: "Term label/synonym",
  sourceCardinality: "Source cardinality",
  targetCardinality: "Target cardinality",
  loading: "Loading...",
  validationLoadingError:
    "Connection to validation server unsuccessful. Please reload to try again.",
  pleaseReload:
    "Error: Cannot find any vocabulary. Please check the vocabulary IRI(s).",
  connectionError:
    "Error loading a vocabulary - please check the console for details.",
  spreadLinks: "Explode links",
  spreadRelationships: "Explode relations",
  links: "Links",
  relationships: "Relationships",
  linkType: "Type",
  searchStereotypes: "Search...",
  selectRelationship: "Select from existing relationships",
  createNewRelationship: "Create new relationship",
  showUsedRelationships: "Show used relationships",
  untitled: "Untitled diagram",
  none: "",
  cancel: "Cancel",
  modalRemoveConceptConnectionsDescription:
    "Warning: the term you are about to delete is connected to terms from outside the listed vocabularies with relations that cannot be deleted here. As such, these relations will remain in the database:",
  menuPanelHelp: "Help",
  removeTrope: "Unassign trope from term",
  assignTrope: "Assign another trope to term",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  default: "Default",
  menuPanelSettings: "Settings",
  menuPanelCenterView: "Center view",
  menuPanelZoom: "Restore zoom",
  menuPanelFitContent: "Scale content to fit view",
  close: "Close",
  confirm: "Confirm",
  savedChanges: "✔ Saved successfully.",
  stableConnection: "You are connected to the DB.",
  brokenConnection: "Your connection to the DB has been interrupted.",
  description: "Description",
  vocabularyNotFound: "Vocabulary definition URL is missing or incorrect",
  validate: "Validate",
  modalRemoveConceptTitle: "Remove term?",
  modalRemoveDiagramTitle: "Remove diagram?",
  modalRemoveDiagramDescription:
    "Are you sure you want to remove the diagram? The layout of the diagram will be lost!",
  connectionVia: "using link",
  diagram: "in diagram",
  modalRemoveConceptDescription: "Are you sure you want to remove the term?",
  definitions: "Definitions",
  representationCompactSwitch: "Switch to Compact view",
  representationFullSwitch: "Switch to Full view",
  generateDiagramImageWithIRIData: "Embed view & IRI data into SVG",
  generateDiagramImageWithBackground: "Export with transparent background",
  showStereotypes: "View stereotypes",
  showIncompatibleLinks: "Display incompatible links",
  hideStereotypes: "Hide stereotypes",
  modalNewElemDescription:
    "Enter a label for the new term (these cannot be changed later!):",
  selectTropeTypePlaceholder: "Select trope type",
  modalNewIntrinsicTropeTitle: "Create new intrinsic trope type",
  intrinsicTropes: "Intrinsic trope types",
  groupSearchTerms: "Group results by vocabularies",
  modalNewElemTitle: "Create new term",
  modalNewLinkTitleLink: "Create new link",
  modalNewLinkTitleRelationship: "Create new relationship",
  changelog: "Changelog",
  modalNewLinkDescriptionLink: "Choose a link from the selection below:",
  modalNewLinkDescriptionRelationship:
    "Choose a relationship from the selection below:",
  labels: "Labels",
  delete: "Delete",
  fileProjectSettingsDescriptions: "Descriptions",
  help: "Help",
  modalNewElemError: "You must enter a label in order to create a new term.",
  selectVocabulary: "Term will be created in:",
  fromList: "From list",
  otherVocabularies: "Other vocabularies",
  view: "View",
  switchColors: "Vocabulary color scheme",
  reportIssue: "Report an issue",
  reportEnhancement: "Suggest an improvement",
  changelogButton: "Changelog",
  errorInvalidCardinality: "Set cardinality is invalid",
  errorParsingEnvironmentVariable:
    "Unable to parse variable from the environment",
  errorParsingKeycloakURL:
    "Unable to parse Keycloak URL from the OIDC endpoint",
  errorParsingKeycloakRealm:
    "Unable to parse Keycloak Realm from the OIDC endpoint",
  connectionListAddSelection: "Add selection onto the canvas",
  connectionListEmptySelection: "Clear selection",
  connectionListShowSelection: "Select visible connections",
  connectionListShowFilter: "Show/hide filter options",
  connectionListEmptyFilter: "Disable filter",
  downloadingTerms: "Adding selected term(s) into the term list...",
  vocabularyNotFullyRepresented:
    "The term list does not contain all terms from this vocabulary. Click here to show all terms of this vocabulary.",
  criticalAlert: "Critical alert",
  obsoleteDiagramsAlertIntro:
    "OntoGrapher has detected that a vocabulary has been removed. As such, these following diagrams are unpublishable and should be deleted:",
  obsoleteDiagramsAlertInfo:
    "Only the copies are deleted; the originals are left untouched. Keeping these diagrams ensures conflicts during publishing.",
  obsoleteDiagramsAlertDeleteDiagrams: "Delete these diagrams",
  vocabulariesPlural: "vocabularies",
  vocabulariesMorePlural: "vocabularies",
} as const;
